const ACTIONS = {
  UPDATE_QUIZ_TYPE: "UPDATE_QUIZ_TYPE",
  START_EDIT: "START_EDIT",
  CLEAR_EDIT: "CLEAR_EDIT",
};

export default ACTIONS;
